import Kindle from '../shared/kindle.js'
import { div } from 'quickelement'

let clocks =  [
  {label: 'TOK', utc: 9},
  {label: 'BLR', utc: 5.5},
  {label: 'NYC', utc: -4},
  {label: 'SFO', utc: -7}
]

// from clock.js
function pad(string) {
  if (("" + string).length < 2) string = "0" + string;
  return string;
}

const getTimeForUtcOffset = (utcOffset) => {
  const oneHour = 60 * 60 * 1000;
  let offsetFromUTC = new Date().getTimezoneOffset() / 60
  let offsetTime = new Date()
  offsetTime.setTime(offsetTime.getTime() + (offsetFromUTC + utcOffset) * oneHour)

  if (String.prototype.padStart) {
    return {
      hour: offsetTime.getHours().toString().padStart(2, '0'), 
      minutes: offsetTime.getMinutes().toString().padStart(2, '0')
    }
  } else {
    return {
      hour: pad(offsetTime.getHours().toString()),
      minutes: pad(offsetTime.getMinutes().toString()),
    }
  }
}

const createClock = (label, utcOffset) => {
  let time = getTimeForUtcOffset(utcOffset)
  //let time = { hour: '00', minutes: '00'}
  return div('clock', {id: label, 'data-utc': utcOffset}, [
    div('label', {}, label),
    div('time', {}, [
      div('hour', {}, time.hour),
      div('minutes', {}, time.minutes)
    ])
  ])
}

const updateClock = (label, utcOffset) => {
  let time = getTimeForUtcOffset(utcOffset)
  let clockElement = document.querySelector('#' + label)
  if (clockElement) {
    let hourElement = clockElement.querySelector('.hour')
    hourElement.innerHTML = time.hour
    let minuteElement = clockElement.querySelector('.minutes')
    minuteElement.innerHTML = time.minutes
  }
}

// URL hash can configure the clock:
// http://localhost:5000/multiclock/index.html#NYC,-5|TOK,9 
//  = NYC offset UTC-5
//  = TOK offset UTC+9
const parseClocksFromURL = () => {
  let hash = window.location.hash
  if (!hash || hash.length < 1) {
    return clocks
  }

  hash = decodeURIComponent(hash).slice(1)
  let clockOffsets = hash.split('|')
  let parsedClocks = []
  for (let clockOffset of clockOffsets) {
    let labelOffset = clockOffset.split(',')
    if (labelOffset.length > 1) {
      parsedClocks.push({
        label: labelOffset[0], 
        utc: parseFloat(labelOffset[1])
      })
    }
  }
  return parsedClocks
}

const initClocks = () => {
  clocks = parseClocksFromURL()
  const clocksElement = document.querySelector('#clocks')
  for (let clock of clocks) {
    let clockElement = createClock(clock.label, clock.utc)
     clocksElement.appendChild(clockElement)
  }
  setInterval(updateClocks, 1000 * 20)  // update every 20 secs.
}

const updateClocks = () => {
  Kindle.refreshScreen()
  for (let clock of clocks) {
    updateClock(clock.label, clock.utc)
  }
}

document.addEventListener("DOMContentLoaded", function() {
  initClocks()
});